<template>
  <div>
    <div class="bg-blue">
      <div
        class="flex justify-between items-center container h-auto lg:h-20 text-white"
      >
        <div class="py-5 mr-4 w-32 lg:w-48">
          <img src="../assets/logo.png" alt="MEYLE Logo" />
        </div>
        <div v-if="loaded" class="flex -mx-2">
          <button class="flex items-center p-2" @click="toggleLocale">
            <span class="uppercase mr-2">{{ $i18n.locale }}</span>
            <img src="../assets/language.png" alt="" />
          </button>
          <button class="lg:hidden p-2" @click="isOpen = !isOpen">
            <MenuIcon v-if="!isOpen" />
            <XIcon v-else />
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loaded"
      class="container py-2 lg:py-6 nav"
      :class="{ 'is-open': isOpen }"
    >
      <div class="flex flex-col lg:flex-row -mx-4">
        <a
          @click="isOpen = false"
          href="#mein-termin"
          class="lg:px-4 py-2 lg:py-0 block uppercase text-blue"
        >
          {{ $t('meinTermin') }}
        </a>
        <a
          @click="isOpen = false"
          href="#so-funktionierts"
          class="lg:px-4 py-2 lg:py-0 block uppercase text-blue"
        >
          {{ $t('soFunktionierts') }}</a
        >
        <a
          @click="isOpen = false"
          href="#vorschau"
          class="lg:px-4 py-2 lg:py-0 block uppercase text-blue"
        >
          {{ $t('vorschau') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { MenuIcon, XIcon } from 'vue-feather-icons';

export default {
  components: {
    MenuIcon,
    XIcon
  },

  props: {
    loaded: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleLocale() {
      if (this.$i18n.locale === 'de') {
        this.$i18n.locale = 'en';
      } else {
        this.$i18n.locale = 'de';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav {
  display: none;

  &.is-open {
    display: block;
  }

  @screen lg {
    display: block;
  }
}
</style>
